import PropTypes from 'prop-types';
import React from 'react';
import { motion } from 'framer-motion';
// material
import {
  Box,
  Grid,
  Container,
  Typography,
  Slide,
  Stack,
  TextField,
  Button,
  Autocomplete,
  Checkbox,
  Switch
} from '@mui/material';
import { Icon } from '@iconify/react';
import { alpha, useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
// components
import arrowBackFilled from '@iconify/icons-eva/arrow-back-fill';
import RequestsPackage from './RequestPackage';

import * as myLayananService from '../../../services/mylayanan';
import * as tokenServices from '../../../services/token';
import RekomendasiCTA from '../../RekomendasiCTA';
import findIndex from '../../../utils/indexFinder';

// ----------------------------------------------------------------------

RequestsPackages.propTypes = {
  item: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  rekomendasis: PropTypes.object.isRequired,
  setMenu: PropTypes.func.isRequired,
  setIsHostingTokenValidated: PropTypes.func.isRequired
};

export default function RequestsPackages({
  user,
  item: items,
  handleClick,
  tipePermohonan,
  setIsHostingTokenValidated,
  isHostingTokenValidated,
  token,
  setToken
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectedPackage, setSelectedPackage] = React.useState({});
  const [fieldErrors, setFieldErrors] = React.useState({ token: { error: false, message: '' } });
  const [isNeedHosting, setIsNeedHosting] = React.useState(false);

  React.useEffect(() => {
    if (!isNeedHosting) {
      setSelectedPackage({});
      handleClick({});
    }
  }, [isNeedHosting]);

  const checkToken = async () => {
    if (!token && selectedPackage?.meta?.is_token_required) return toast.error('Token belum diisi');
    let tokenIsValid = false;

    try {
      if (selectedPackage?.meta?.is_token_required) {
        const tokenData = await tokenServices.getByID(token);
        if (tokenData.data.id) {
          tokenIsValid = true;
          setIsHostingTokenValidated(true);
          toast.success('Token ditemukan');
        }
        if (tokenData.data.attributes.is_used) {
          tokenIsValid = false;
          return toast.error('Token sudah digunakan');
        }
      }

      if (selectedPackage?.meta?.is_token_required && !tokenIsValid) {
        toast.error('Maaf, token tidak valid');
        return setFieldErrors({
          ...fieldErrors,
          token: { error: true, message: 'Token tidak valid' }
        });
      }
    } catch (error) {
      toast.error('Token tidak ditemukan');
    }
  };

  // const createPermohonan = async () => {
  //   if (!user?.attributes?.id_instansi) return toast.error('ID Instansi tidak ditemukan');
  //   if (!user?.attributes?.id) return toast.error('ID User tidak ditemukan');
  //   if (!selectedPackage.id) return toast.error('Harap pilih paket terlebih dahulu');
  //   if (!rekomendasi.id) return toast.error('ID rekomendasi tidak ditemukan');

  //   const currentRekomendasi = rekomendasis[findIndex(rekomendasis, rekomendasi?.id, 'id')];

  //   if (currentRekomendasi?.meta?.attributes?.status !== 'approved')
  //     return toast.error(
  //       `Maaf, permohonan rekomendasi ${currentRekomendasi?.meta?.attributes?.name} belum disetujui`
  //     );

  //   if (!token && selectedPackage?.meta?.is_token_required) return toast.error('Token belum diisi');
  //   let tokenIsValid = false;

  //   try {
  //     if (selectedPackage?.meta?.is_token_required) {
  //       const tokenData = await tokenServices.getByID(token);
  //       if (tokenData.data.id) tokenIsValid = true;
  //       if (tokenData.data.attributes.is_used) {
  //         tokenIsValid = false;
  //         return toast.error('Token sudah digunakan');
  //       }
  //     }

  //     if (selectedPackage?.meta?.is_token_required && !tokenIsValid) {
  //       toast.error('Maaf, token tidak valid');
  //       return setFieldErrors({
  //         ...fieldErrors,
  //         token: { error: true, message: 'Token tidak valid' }
  //       });
  //     }
  //     try {
  //       const body = {
  //         data: {
  //           type: selectedPackage.type,
  //           id: '1',
  //           attributes: {
  //             hosting: selectedPackage.attributes.name,
  //             id_kategori_layanan: selectedPackage.type,
  //             id_rekomendasi: rekomendasi.id,
  //             id_paket_layanan: selectedPackage.id,
  //             id_instansi: user?.attributes?.id_instansi,
  //             requestor: user?.attributes?.id,
  //             status: 'draft',
  //             id_jenis_permohonan: selectedPackage.type
  //           },
  //           meta: {
  //             hosting: selectedPackage
  //           }
  //         }
  //       };
  //       const result = await myLayananService.addLayanan(body);
  //       if (result) {
  //         try {
  //           const tokenBody = {
  //             id: token,
  //             used_by: user?.attributes?.id
  //           };
  //           const tokenResult = await tokenServices.updateToken(tokenBody);

  //           if (tokenResult) {
  //             toast.success('Draft Permohonan berhasil dibuat');
  //             navigate('/dashboard/services');
  //           }
  //         } catch (error) {
  //           toast.error(error.message);
  //         }
  //       }
  //     } catch (error) {
  //       toast.error(error.message);
  //     }
  //   } catch (error) {
  //     toast.error('Token tidak ditemukan');
  //   }
  // };

  return (
    <Stack direction="column" spacing={1}>
      {['new_subdomain_hosting', 'new_hosting', 'archive'].includes(tipePermohonan) && (
        <>
          <Box sx={{ pb: 2 }}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="h4">Pilihan Paket Hosting</Typography>
            </Stack>
          </Box>

          <Box sx={{ pb: 2, mb: 2 }}>
            <Grid container spacing={3}>
              {!_.isEmpty(items) &&
                items.map((item) => (
                  <Grid item xs={6} md={3} lg={3}>
                    <RequestsPackage
                      item={item}
                      handleClick={() => {
                        if (selectedPackage.id === item.id) {
                          setSelectedPackage({});
                          handleClick({});
                        } else {
                          setSelectedPackage(item);
                          handleClick(item);
                        }
                      }}
                      selectedPackage={selectedPackage}
                    />
                  </Grid>
                ))}
            </Grid>
          </Box>

          {selectedPackage?.meta?.is_token_required && (
            <Box pb={2}>
              {['new_subdomain_hosting'].includes(tipePermohonan) && (
                <Stack direction="column" spacing={1}>
                  <Stack direction="row" spacing={2}>
                    <TextField
                      style={{ width: 300 }}
                      label="Masukkan token"
                      required
                      size="small"
                      onChange={(e) => setToken(e.target.value)}
                      error={fieldErrors.token.error}
                      helperText={fieldErrors.token.message}
                      disabled={isHostingTokenValidated}
                      value={token}
                    />
                    <Button
                      variant="contained"
                      onClick={checkToken}
                      disabled={isHostingTokenValidated}
                    >
                      Cek Token
                    </Button>
                  </Stack>
                  <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                    {isHostingTokenValidated && 'Token ditemukan'}
                  </Typography>
                </Stack>
              )}
            </Box>
          )}
        </>
      )}
    </Stack>
  );
}
